import { calmTokens as t } from '../../shared/tokens';

export default function ForecastEmptyState() {
  return (
    <div
      style={{
        marginTop: 8,
        padding: '40px 24px',
        background: t.surface,
        border: `1px solid ${t.border}`,
        borderRadius: 16,
        textAlign: 'center',
        color: t.textDim,
        fontFamily: t.fontUi,
      }}
    >
      <div
        style={{
          fontFamily: t.fontDisp,
          fontSize: 20,
          fontWeight: 500,
          letterSpacing: -0.3,
          color: t.text,
          marginBottom: 6,
        }}
      >
        Aucune opération récurrente
      </div>
      <div style={{ fontSize: 13 }}>
        Ajoutez des modèles dans Paramétrage pour voir les prévisions du mois.
      </div>
    </div>
  );
}
